<template lang="pug">
  .step
    .row.flex(v-for="(spouse, spouse_id) in this.family.spouse" :key="spouse_id")
      .label 配偶者
      .text
        v-text-field(v-model="spouse.comment" maxlength="6" @change="change_checkbox")
      .radio
        v-checkbox(label="既に他界" v-model="spouse.exist" @change="change_checkbox")
    .button_area
      button.blue_button(@click="step02") STEP2：遺産入力へ
      BackButton
</template>

<script lang="js">
import BackButton from '@/components/module/BackButton.vue';

export default {
  components: {
    BackButton,
  },
  data: () => ({
    family: {},
  }),
  props: {
    redraw: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    step02() {
      this.$emit('go_step02', '');
    },
    change_checkbox(e) {
      this.$emit('change_family', {family: this.family});
    },
  },
  mounted() {
    const json = localStorage.getItem('_isan_data');
    if (json) {
      this.family = JSON.parse(json);
    }
    if (!this.family.spouse || this.family.spouse.length === 0) {
      this.family = {
        brother: [],
        spouse: [],
        parent: [],
        label: '　本人　',
        comment: '遺産をお持ちの方',
        mode: 1,
      };
      localStorage.setItem('_isan_data', JSON.stringify(this.family));
    }
  },
};
</script>

<style lang="sass" scoped>
.flex
  display: flex
  flex-wrap: wrap
  align-items: center
  width: 100%
  margin: 10px 0

  .label
    width: 20%
    box-sizing: border-box
    text-align: center
  .label_grand_child
    width: 30%
  .text
    width: 50%
    input
      width: 100%
      padding: 10px
      box-sizing: border-box
      border: solid 1px $light-gray
  .text_grand_child
    width: 40%
  .radio
    width: 30%
    box-sizing: border-box
    padding: 0 10px
.button_area
  flex-direction: column
  justify-content: center
  align-items: center
  button
    &:nth-child(2)
      margin-top: 20px
      width: 300px
//.step
//  min-height: 100%
//  display: flex
//  justify-content: center
//  align-items: center
button
  width: 300px
  height: 60px

@media screen and (max-width: $break-header)
  .flex
    .label
      width: 100px
      box-sizing: border-box
      text-align: center
    .label_grand_child
      width: 110px
    .text
      width: 33%
      input
        width: 100%
        padding: 10px
        box-sizing: border-box
        border: solid 1px $light-gray
    .text_grand_child
      width: 30%
    .radio
      width: 110px
      box-sizing: border-box
      padding: 0 10px
</style>